import { render, staticRenderFns } from "./IntegerInput.vue?vue&type=template&id=2fa8907a&"
import script from "./IntegerInput.vue?vue&type=script&lang=js&"
export * from "./IntegerInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports